
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import "bootstrap"
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUserSecret, faUmbrella, faWrench, faTrailer } from '@fortawesome/free-solid-svg-icons';

library.add(faUserSecret, faUmbrella, faWrench, faTrailer)

axios.defaults.baseURL = 'https://uti.umbgrup.ro'//'http://192.168.21.55:8000';//
axios.defaults.withCredentials = true


router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresLogin)) {
        if ((!store.state.authenticated)) {
            next();//next({name: 'login'})
        } else {
            next();
        }
    } else {
        next();
    }
})

// Înregistrare Service Worker (pentru PWA)
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then((registration) => {
                console.log('Service Worker înregistrat cu succes:', registration);
            })
            .catch((error) => {
                console.error('Eroare la înregistrarea Service Worker:', error);
            });
    });
}


const application = createApp(App).use(store).use(router, axios);
application.component('font-awesome-icon', FontAwesomeIcon);

application.mount('#app');
